import { useSnackbar } from 'notistack';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
} from '@mui/material';

import { Role } from '@/types';
import { useDeleteRoleMutation } from '@/services';

export interface DeleteRoleProps extends DialogProps {
  userRole: Role;
  onClose(): void;
}

const DeleteRole: React.FC<DeleteRoleProps> = ({ userRole, onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [deleteRole, deleteRoleResponse] = useDeleteRoleMutation();

  async function handleDeleteRole() {
    try {
      await deleteRole(userRole).unwrap();

      onClose();
    } catch (error) {
      enqueueSnackbar(error.data, { variant: 'error' });
    }
  }

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">{userRole?.name}</DialogTitle>

      <DialogContent dividers>
        <DialogContentText>Вы действительно хотите удалить "{userRole?.name}"?</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" variant="outlined" disabled={deleteRoleResponse.isLoading} onClick={onClose}>
          Закрыть
        </Button>

        <Button variant="contained" disabled={deleteRoleResponse.isLoading} onClick={handleDeleteRole}>
          Да
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteRole;
